'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findCoverRequestEntities = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../../util/constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var findCoverRequestEntities = exports.findCoverRequestEntities = function findCoverRequestEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === _constants.Entity.COVER_REQUEST;
  }, callback);
};

var CoverRequest = function CoverRequest(props) {
  var contentState = props.contentState,
      entityKey = props.entityKey;

  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
      cover = _contentState$getEnti.cover;

  return _react2.default.createElement('mark', {
    'data-covername': cover,
    'aria-label': cover
  }, props.children);
};

CoverRequest.propTypes = {
  children: _propTypes2.default.node,
  entityKey: _propTypes2.default.string,
  contentState: _propTypes2.default.object.isRequired
};
exports.default = CoverRequest;